import restAPI from '@/utils/rest-api'

export default {
    referred(data) {
        return restAPI.post('/referreds', data)
    },
    isUnique(mobile) {
        return restAPI.get(`/referreds/is-unique/mobile/${mobile}`)
    }
}
